import { Box, Button, Flex, useToast } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { api, baseURL } from '../../../services/api'
import { useMutation, useQuery } from 'react-query'
import { Loader } from '../../../components/ComponentLoader/Loader'
import Input from './Input'
import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect, useState } from 'react'
import { SelectCategoryPopover } from './SelectCategoryPopover'
import { SelectColorProductPopover } from './SelectColorProductPopover'
import { useNavigate, useParams } from 'react-router-dom'
import { schemaRegisterProduct } from './schema/schemaRegisterProduct'
import { user } from '../../../helpers/user'
import Select from './Select'
import { SelectFornecedorPopover } from './SelectFornecedorPopover'
import { useDebounce } from '../../../hooks/useDebounce'
import { NCM } from './NCM'

async function fetchData() {
  const response = await baseURL.get('/controle-crm/verifica-produtos-erro')
  return response.data
}

export function CadastroProduto() {
  const { id } = useParams()

  const form = useForm({
    resolver: zodResolver(schemaRegisterProduct),
  })

  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = form

  const { data, isLoading, isError, refetch } = useQuery('verificationProducts', fetchData, {
    enabled: false,
  })

  const codUsu = user

  const navigate = useNavigate()

  const [categorySelected, setCategorySelected] = useState(null)
  const [fornecedorSelected, setFornecedorSelected] = useState(null)

  const [colorSelected, setColorSelected] = useState(null)

  const bloqueiaFornecedores = Array.from({ length: 2 }, (_, index) => {
    return {
      name: index === 0 ? 'Sim' : 'Não',
      value: index === 0 ? 'S' : 'N',
    }
  })

  const toast = useToast({
    position: 'top-right',
  })

  const handleVerificationProducts = async () => {
    try {
      await refetch()
      toast({
        title: 'Dados buscados com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })
    } catch (error) {
      toast({
        title: 'Erro ao buscar dados',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })
    }
  }

  const { mutateAsync } = useMutation(
    async (data) => {
      const response = await baseURL.post('/detalhes-produto/inserir-info-produto', data)

      return response.data
    },
    {
      onSuccess: (data) => {
        navigate(`/financeiro/cadastro-produto/${data}`)
      },
    }
  )

  async function handleRegisterProduct(data) {
    // await new Promise((resolve) => setTimeout(resolve, 5000))

    try {
      await schemaRegisterProduct.parseAsync(data)

      const params = {
        ...data,
        descricao_produto: data.name,
        referencia_fornecedor: data.referenciafornecedor,
        codigo_grupo_produto: data.category.codigo_grupo,
        codigo_usuario: codUsu?.codigo_usuario,
        ncm: data.ncm,
        cest: data.cest,
        nome_fornecedor: data.fornecedor.toUpperCase(),
        nome_cor: data.corproduto.nome_cor,
        id_cor: data.corproduto.id_cor,
      }

      await mutateAsync(params)

      // navigate(`/financeiro/cadastro-produto/2323`)
    } catch (error) {
      console.log(error)
    }
  }

  const camelCaseToWords = (str) => {
    const words = str.split(/(?=[A-Z])/)
    return words.join(' ')
  }

  useEffect(() => {
    if (errors) {
      Object.entries(errors).forEach(([fieldName, error]) => {
        toast({
          title: `Erro ao cadastrar produto no campo ${camelCaseToWords(fieldName)}`,
          description: error.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      })
    }
  }, [errors])

  return (
    <>
      <HeadingPages name="Cadastro de Produtos" />

      {isLoading && <Loader img={'https://imgproductioncrm.s3.us-east-2.amazonaws.com/loading-verde.gif'} />}

      <FormProvider {...form}>
        <Box maxW="1280" mx="auto" w="100%" mt="2rem" display="flex" alignItems="flex-start" justifyContent={'center'}>
          <Button colorScheme="blue" onClick={handleVerificationProducts}>
            Verificar produtos
          </Button>
        </Box>

        <Box maxW="1080" w="full" mx="auto" display="flex" flexDir="column" mb="3rem">
          <Box display="flex" flexDir="column" gap=".7rem" mt="3rem" as="form" onSubmit={handleSubmit(handleRegisterProduct)}>
            <SelectCategoryPopover />

            <Input
              name="name"
              label="Nome do produto"
              placeholder="Nome do produto"
              labelWidth="230px"
              {...register('name')}
              error={errors.name?.message}
            />
            <Input
              name="caracteristicas"
              label="Características"
              placeholder="Características"
              labelWidth="230px"
              {...register('descricao_caracteristica')}
              error={errors.descricao_caracteristica?.message}
            />
            <Flex gap="1">
              <NCM />
              <Input name="cest" label="Cest" placeholder="Cest" type="number" maxW="175px" {...register('cest')} error={errors.cest?.message} />

              <SelectFornecedorPopover
                setFornecedorSelected={setFornecedorSelected}
                fornecedorSelected={fornecedorSelected}
                control={control}
                error={errors.fornecedor?.message}
              />
              <Select
                name="bloqueia_fornecedor"
                label="Bloqueia Fornecedor"
                options={bloqueiaFornecedores}
                control={control}
                placeholder="Selecione"
                error={errors.bloqueia_fornecedor?.message}
              />
            </Flex>

            <SelectColorProductPopover />
            <Input
              name="referenciafornecedor"
              label="Referencia do fornecedor"
              placeholder="Referencia do fornecedor"
              {...register('referenciafornecedor')}
              error={errors.referenciafornecedor?.message}
            />
            <Button
              textTransform="uppercase"
              fontSize="20px"
              maxW="139px"
              w="full"
              mx="auto"
              rounded="full"
              bgColor="#378BBF"
              color="#fff"
              fontWeight="normal"
              _hover={{
                filter: 'brightness(0.9)',
              }}
              type="submit"
              disabled={isSubmitting}
              isLoading={isSubmitting}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      </FormProvider>
    </>
  )
}
